<template>
  <div style="margin-bottom: 56px" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/home/juhan.png" alt="巨航" />
      </div>
      <div class="navbar_right">
        <!-- <div class="nav_tiyan" @click="gotoExperience">立即体验</div> -->
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <router-link
          class="menu_item"
          to="/home"
          :class="currentActive === 0 ? 'active' : ''"
          >首页</router-link
        >
        <div v-for="(item, index) in routers" :key="index">
          <div
            class="menu_item"
            :class="currentActive === index + 1 ? 'active' : ''"
            @click="showSubMenu(index)"
          >
            {{ item.title }}
          </div>
          <div class="item_options" v-show="selectedIndex === index">
            <span
              v-for="(rData, i) in item.subRouters"
              :key="`sub${i}`"
              @click="changeCurrentPage(rData.index)"
              >{{ rData.title }}</span
            >
          </div>
        </div>

        <!-- <div
          class="menu_item"
          @click="changeSystemShow"
          :class="currentActive === 1 ? 'active' : ''"
        >
          核心系统
        </div>
        <div class="item_options" v-show="systemShow">
          <span @click="changeCurrentPage('/system/1')">政务排队叫号系统</span>
           <a href="/system/2">门诊排队叫号系统</a>
          <a href="/system/3">车辆排队叫号系统</a>
          <a href="/system/4">手持排队叫号系统</a> 
        </div> -->
        <!-- <div
          class="menu_item"
          @click="changeProductShow"
          :class="currentActive === 2 ? 'active' : ''"
        >
          智能硬件
        </div>
        <div class="item_options" v-show="productShow">
          <a href="/production/1">排队机</a>
          <a href="/production/2">自助终端设备</a>
          <a href="/production/3">显示屏</a>
          <a href="/production/4">呼叫器评价器</a>
          <a href="/production/5">广告机</a>
          <a href="/production/6">会议一体机 工控机</a>
        </div>
        <div
          class="menu_item"
          @click="changeCenterShow"
          :class="currentActive === 3 ? 'active' : ''"
        >
          客户案例
        </div>
        <div class="item_options" v-show="centerShow">
          <a href="/customer/1" style="height: 33.3%">政务厅</a>
          <a href="/customer/2" style="height: 33.3%">营业厅</a>
          <a href="/customer/3" style="height: 33.3%">医院</a>
        </div>
        <div
          class="menu_item"
          @click="changefireShow"
          :class="currentActive === 4 ? 'active' : ''"
        >
          了解巨航
        </div>
        <div class="item_options" v-show="fireShow">
          <a href="/about/1">关于我们</a>
          <a href="/contact/1">联系我们</a>
        </div> -->
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
      systemShow: false,
      routers: [],
      routerMap: new Map(),
      currentItem: {},
      selectedIndex: 0
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  created() {
    this.initData()
    this.selectedIndex = 0
  },
  methods: {
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeProductShow() {
      this.productShow = !this.productShow
      this.centerShow = false
      this.fireShow = false
      this.systemShow = false
    },
    changeSystemShow() {
      this.systemShow = !this.systemShow
      this.centerShow = false
      this.fireShow = false
      this.productShow = false
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow
      this.fireShow = false
      this.productShow = false
      this.systemShow = false
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
      this.productShow = false
      this.systemShow = false
    },
    showSubMenu(index) {
      console.log(index, "showSubMenu")
      switch (index) {
        case 0:
          this.changeSystemShow()

          break;
        case 1:
          this.changeProductShow()
          break;
        case 2:
          this.changeCenterShow()
          break;
        case 3:
          this.changefireShow()
          break;
      }
      this.currentItem = this.routers[index]
      this.selectedIndex = index
    },
    gotoExperience() {
      this.$router.push('/demo').catch((v) => { })
    },
    gobackHome() {
      this.$router.replace('/home').catch((v) => { })
    },
    changeCurrentPage(index) {
      let path = this.routerMap.get(index)

      console.log(index, path, "this.activeIndex**")

      this.$router.push(path).catch((v) => { })
    },
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH

      fetch(baseUrl + '/home/data.json')
        .then(response => response.json())
        .then(data => {
          let { routers } = data
          this.routers = routers

          let map = new Map()
          routers.forEach(item => {
            map.set(item.index, item.path)

            if (item.subRouters) {
              item.subRouters.forEach(i => {
                map.set(i.index, i.path)
              })
            }
          })
          this.routerMap.clear()

          this.routerMap = map

        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15px 0 15px 15px;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    background: #fff;
    img {
      width: 46%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56px;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .nav_tiyan {
      width: 88px;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }

    .nav_btns {
      width: 56px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 30px;
      }
    }
  }
}
.active {
  color: #f39c00 !important;
  font-weight: bold;
}
.nav_menu {
  position: absolute;
  width: 100%;
  height: 450px;
  list-style: none;
  left: 0;
  right: 0;
  top: -1000px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: #eff0f1;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: all 0.8s;
  .menu_item {
    width: 100%;
    height: 40px;
    font-size: 16px;
    background: #eff0f1;
    color: #1c212d;
    padding: 30px;
    display: flex;
    align-items: center;
  }
  .item_options {
    width: 100%;
    padding: 5px 10px;
    min-height: 150px;
    font-size: 14px;
    background: #fff;
    a,
    span {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 25%;
      padding: 20px 30px;
    }
  }
}
</style>